import { getHttpService } from "../services/http.service";
import { SettingsEndpoint } from "../endpoints/SettingsEndpoint";
import { Observable } from "rxjs";


export const getModuleSettings = (
  restaurantId?: string,
  bookingId?: string,
  bookingToken?: string,
  preview?: string
): Observable<any> => {
  const endpoint = new SettingsEndpoint();
  var queryParams = [];
  if (restaurantId !== undefined && /^[0-9]+$/.test(restaurantId)) {
    queryParams.push({
      queryParamName: "restaurant_id",
      queryParamValue: restaurantId,
    });
  }
  if (bookingId !== undefined && bookingToken !== undefined) {
    queryParams.push({
      queryParamName: "booking_id",
      queryParamValue: bookingId,
    });
    queryParams.push({
      queryParamName: "booking_token",
      queryParamValue: bookingToken,
    });
  }
  if (preview) {
    queryParams.push({
      queryParamName: "preview",
      queryParamValue: preview,
    });
  }
  endpoint.setQueryParams(queryParams);
  return getHttpService().get(endpoint);
};
